import { getText, Tlt, useDispatch } from "@clairejs/react";
import { useNavigator } from "@clairejs/react-web";
import { Card, Form, Input, Modal } from "antd";
import { useState } from "react";

import imgFree from "../../assets/images/free.svg";

import { DataStore } from "../../store/store";
import { userActions } from "../../store/action/user";
import { useCaptcha, useSignInSignUp } from "../../store/hooks/login";

import { RedColor } from "../../utils/style";

import CredentialForm from "../common/login/credential-form";
import OtpInput from "../../components/otp-input";
import OtpDialog from "../common/login/otp";

const Login = () => {
    const navigator = useNavigator();
    const redirectUri = navigator.getQueries().redirect;
    const { execute } = useCaptcha();

    const dispatchUser = useDispatch(DataStore, (s) => s.me);

    const [newPassword, setNewPassword] = useState("");

    const {
        loading,
        login,
        reseting,
        performReset,
        showOtp,
        setShowOtp,
        setOtp,
        resetEmail,
        showResetPassword,
        hideResetPassword,
        otpError,
        setOtpError,
        performVerify,
    } = useSignInSignUp({
        solveCaptcha: execute,
        onSessionCreated: async () => {
            const user = await dispatchUser(userActions.fetchCurrentUser());
            //--- to home screen
            navigator.navigate(redirectUri ? redirectUri : user?.user.isReferer ? "/admin" : "/");
        },
    });

    return (
        <div
            style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flex: 1,
            }}>
            <Card>
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 13,
                    }}>
                    <img
                        src={imgFree}
                        style={{
                            height: 55,
                            aspectRatio: 1,
                            objectFit: "contain",
                            margin: "35px 0",
                            cursor: "pointer",
                        }}
                        alt="logo"
                        onClick={() => navigator.navigate("/")}
                    />
                    <h3>
                        <Tlt template="Sign in to your account" />
                    </h3>
                    <CredentialForm
                        progress={loading}
                        disabled={loading}
                        handleCredential={login}
                        submitButtonText={getText(<Tlt template="Sign in" />)}
                    />
                </div>
            </Card>
            {showOtp && (
                <OtpDialog
                    onCancel={() => setShowOtp(undefined)}
                    verifyOtp={performVerify}
                    otpError={!!otpError}
                    onChange={setOtp}
                />
            )}
            {showResetPassword && (
                <Modal
                    open={true}
                    title={getText(<Tlt template="Reset your password" />)}
                    maskClosable={false}
                    onCancel={hideResetPassword}
                    onOk={() => performReset(newPassword)}
                    okButtonProps={{ disabled: !newPassword, loading: reseting }}>
                    <Form layout="vertical">
                        <Form.Item label={getText(<Tlt template="Email address" />)}>
                            <span style={{ fontWeight: "bold" }}>{resetEmail}</span>
                        </Form.Item>
                        <Form.Item label={getText(<Tlt template="New password" />)}>
                            <Input.Password onChange={(e) => setNewPassword(e.target.value)} />
                        </Form.Item>
                        {showOtp && (
                            <Form.Item label={getText(<Tlt template="Verification code" />)}>
                                <OtpInput
                                    disabled={loading}
                                    otpLength={6}
                                    onChange={(e) => {
                                        setOtp(e);
                                        setOtpError("");
                                    }}
                                />
                                <div style={{ color: RedColor, textAlign: "center", marginTop: 13 }}>
                                    {otpError && <Tlt template="The verification code is incorrect." />}
                                </div>
                            </Form.Item>
                        )}
                    </Form>
                </Modal>
            )}
        </div>
    );
};

export default Login;
